export function createExportWarnings() {
  const list = [];
  return {
    push(msg) {
      if (msg) list.push(msg);
    },
    list: () => [...list],
  };
}
